/**
 * Created by 枯荣<panjiankang@cai-inc.com> on 2019-08-06 16:34.
 */
const BaseComponent = require( 'base/common-category' );
const Server = require( 'helper/server' );
const FRAME = require( 'helper/frame' );
const { initMenu } = require( 'purchasing-federation/common/config/member-center-menu' );

const detailTpl = Handlebars.templates[ 'templates/category-detail-tpl' ];

class MessageCenterDetail extends BaseComponent {
  constructor() {
    super( {
      config: {
        hightSearch: false
      }
    } );
  }

  async init() {
    const data = initMenu( 'MessageCenter', {}, {} );
    this.$el.find( '.list__nav-title' ).html( data.text );
    this.$el.find( '.treeData[name="tree-data"]' ).html( JSON.stringify( data ) );
    super.init();
    this.initialization();
  }

  createTitle( title, time, source ) {
    const html = `
      <h2 style="text-align: center; margin: 0 0 15px 0">${ title }</h2>
      <p style="text-align: center">
        ${ source ? `<span>来源：${ source }</span>` : '' }
        ${ time ? `<span>发布时间：${ time }</span>` : '' }
      </p>
    `;
    return html;
  }

  async initialization() {
    this.$el.find( '.block__content' ).html( detailTpl() );
    const { messageid: messageId } = this.query.params || {};
    try {
      const data = await Server.getMessageDetail( { messageId } );
      const { attachements = [], message = {} } = data || {};
      const { messageContent, messageTitle, createTime } = message;
      const title = this.createTitle( messageTitle, createTime );
      FRAME.initializeIframe( '#article-content', `${ title }${ messageContent }` );
    }
    catch ( e ) {
      alert( e.responseText || '未知错误' );
    }
  }
}

module.exports = MessageCenterDetail;
